import React, { useState } from "react";
import { compose } from "redux";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";

import _ from "underscore";
import ClaimsWrapper from "../../../../shared/ui/Claim.Wrapper";

import { organisationConnector } from "../../../../services/users/organisations/connector";
import { allClaimsOtherThanAml } from "../../../../shared/ClaimLists/Claim.Aml.All.List";
import { supportedCurrencies } from "../../../../services/users/organisations/helper";
import { UsersOverviewConnector } from "../../../../services/users/connectors/Users.Overview.Connector";

export const OriginatorsComponent = ({ addOriginator, personId }) => {
  const [state, changeState] = useState({
    Name: "",
    BuyBack: false,
    CountryAssetClasses: {
      Poland: { enabled: false, AssetClasses: [] },
      Sweden: { enabled: false, AssetClasses: [] },
      Finland: { enabled: false, AssetClasses: [] },
    },
    CreditType: "",
    LendingCompany: "",
    TargetReturnPercentFrom: "",
    TargetReturnPercentTo: "",
    TermInMonthsFrom: "",
    TermInMonthsTo: "",
    PenaltyInterest: false,
    BuyBackAgreementPercent: "",
    Currency: supportedCurrencies[0].value,
    OwnerPersonId: personId,
  });
  const [clicked, changeClicked] = useState(false);

  const assetClassesMenuOptions = [
    <MenuItem value={"ConsumerCredit"} key={1}>
      Consumer Credit
    </MenuItem>,
    <MenuItem value={"Factoring"} key={2}>
      Factoring
    </MenuItem>,
    <MenuItem value={"SMECredit"} key={3}>
      SME Credit
    </MenuItem>,
  ];

  const creditTypesMenuOptions = [
    <MenuItem value={"BusinessLoans"} key={1}>
      Business Loans
    </MenuItem>,
    <MenuItem value={"Factoring"} key={2}>
      Factoring
    </MenuItem>,
    <MenuItem value={"DebtCollectionPortfolios"} key={3}>
      Debt Collection Portfolios
    </MenuItem>,
    <MenuItem value={"ConsumerLoans"} key={4}>
      Consumer Loans
    </MenuItem>,
    <MenuItem value={"RealEstateProjects"} key={5}>
      Real Estate Projects
    </MenuItem>,
    <MenuItem value={"RentalProjects"} key={6}>
      Rental Projects
    </MenuItem>,
    <MenuItem value={"ImportFinances"} key={7}>
      Import Finances
    </MenuItem>,
    <MenuItem value={"ConsumerLoans80"} key={8}>
      Consumer Loans 80
    </MenuItem>,
    <MenuItem value={"ConsumerLoans100"} key={9}>
      Consumer Loans 100
    </MenuItem>,
    <MenuItem value={"LitigationFunding"} key={10}>
      Litigation funding
    </MenuItem>,
  ];

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6">
          <h4>Add new originator</h4>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div>
            <TextField
              size="small"
              variant="outlined"
              label="Originator Name"
              style={{ flexBasis: "33%" }}
              value={state.Name}
              name="Name"
              onChange={handleChange}
            />
          </div>
          <div>
            <TextField
              label="Currency"
              size="small"
              variant="outlined"
              name="Currency"
              select
              id="CurrencyForOriginator"
              value={state.Currency}
              onChange={handleChange}
            >
              {supportedCurrencies.map((currency) => {
                return (
                  <MenuItem key={currency.value} value={currency.value}>
                    {" "}
                    {currency.label}{" "}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
          <div>
            <TextField
              size="small"
              variant="outlined"
              select
              name="CreditType"
              label="Credit Type"
              value={state.CreditType}
              onChange={handleChange}
            >
              {creditTypesMenuOptions}
            </TextField>
          </div>
          <div>
            <TextField
              name="LendingCompany"
              size="small"
              variant="outlined"
              placeholder="Lending company"
              value={state.LendingCompany}
              onChange={handleChange}
            />
          </div>
          <div>
            <TextField
              name="TargetReturnPercentFrom"
              size="small"
              placeholder="Target Return Percent From"
              variant="outlined"
              value={state.TargetReturnPercentFrom}
              onChange={handleChange}
            />
            <TextField
              name="TargetReturnPercentTo"
              size="small"
              placeholder="Target Return Percent To"
              variant="outlined"
              value={state.TargetReturnPercentTo}
              onChange={handleChange}
            />
          </div>
          <div>
            <TextField
              name="TermInMonthsFrom"
              size="small"
              placeholder="Term in months from"
              variant="outlined"
              value={state.TermInMonthsFrom}
              onChange={handleChange}
            />
            <TextField
              name="TermInMonthsTo"
              size="small"
              placeholder="Term in months to"
              variant="outlined"
              value={state.TermInMonthsTo}
              onChange={handleChange}
            />
          </div>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  name="PenaltyInterest"
                  checked={state.PenaltyInterest}
                  onClick={handleCheckboxChange}
                />
              }
              label="Penalty Interest"
            />
          </div>
          <div>
            <TextField
              name="BuyBackAgreementPercent"
              size="small"
              placeholder="Buy Back Agreement Percent"
              variant="outlined"
              value={state.BuyBackAgreementPercent}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <FormControlLabel
            control={
              <Checkbox
                checked={state.CountryAssetClasses.Sweden.enabled}
                onClick={() => switchCountry("Sweden")}
              />
            }
            label="Sweden"
          />
          <br />
          {state.CountryAssetClasses.Sweden.enabled ? (
            <div>
              <TextField
                size="small"
                variant="outlined"
                select
                label="Asset class"
                value={state.CountryAssetClasses.Sweden.AssetClasses}
                onChange={(event) => changeAssetClasses("Sweden", event)}
              >
                {assetClassesMenuOptions}
              </TextField>
            </div>
          ) : undefined}
        </div>
        <div className="col-md-4">
          <FormControlLabel
            control={
              <Checkbox
                checked={state.CountryAssetClasses.Poland.enabled}
                onClick={() => switchCountry("Poland")}
              />
            }
            label="Poland"
          />
          <br />
          {state.CountryAssetClasses.Poland.enabled ? (
            <div>
              <TextField
                size="small"
                variant="outlined"
                select
                label="Asset class"
                value={state.CountryAssetClasses.Poland.AssetClasses}
                onChange={(event) => changeAssetClasses("Poland", event)}
              >
                {assetClassesMenuOptions}
              </TextField>
            </div>
          ) : undefined}
        </div>
        <div className="col-md-4">
          <FormControlLabel
            control={
              <Checkbox
                checked={state.CountryAssetClasses.Finland.enabled}
                onClick={() => switchCountry("Finland")}
              />
            }
            label="Finland"
          />
          <br />
          {state.CountryAssetClasses.Finland.enabled ? (
            <div>
              <TextField
                size="small"
                variant="outlined"
                select
                label="Asset class"
                value={state.CountryAssetClasses.Finland.AssetClasses}
                onChange={(event) => changeAssetClasses("Finland", event)}
              >
                {assetClassesMenuOptions}
              </TextField>
            </div>
          ) : undefined}
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => _addOriginator()}
            >
              Add originator
            </Button>
          </ClaimsWrapper>
          <p style={{ color: "red" }}>
            <b>{clicked && validationText()}</b>
          </p>
        </div>
      </div>
    </React.Fragment>
  );

  function handleChange(e) {
    const { name, value } = e.target;
    changeState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  function handleCheckboxChange(e) {
    const { name, checked } = e.target;
    changeState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  }

  function validationText() {
    // for now need to add validation
    let validationText = "";

    if (!state.Name) validationText = "Originator Name missing";
    return validationText;
  }

  function _addOriginator() {
    changeClicked(true);
    if (!validationText()) {
      let countryAssetClasses = _.omit(state.CountryAssetClasses, (val) => {
        return !val.enabled;
      });

      countryAssetClasses = _.mapObject(countryAssetClasses, (val) => {
        return val.AssetClasses;
      });

      let countryAssetClassesResult = [];
      let countryAssetClassesKeys = Object.keys(countryAssetClasses);

      for (let i = 0; i < countryAssetClassesKeys.length; i++) {
        let country = countryAssetClassesKeys[i];
        for (let j = 0; j < countryAssetClasses[country].length; j++)
          countryAssetClassesResult.push({
            Country: country,
            AssetClass: countryAssetClasses[country][j],
            BuyBack: false,
          });
      }

      addOriginator({
        ...state,
        CountryAssetClasses: countryAssetClassesResult,
      });
    }
  }

  function changeAssetClasses(country, event) {
    changeState((prevState) => ({
      ...prevState,
      CountryAssetClasses: {
        ...prevState.CountryAssetClasses,
        [country]: {
          AssetClasses: [event.target.value],
          enabled: prevState.CountryAssetClasses[country].enabled,
        },
      },
    }));
  }

  function switchCountry(countryToChange) {
    changeState((prevState) => ({
      ...prevState,
      CountryAssetClasses: {
        ...prevState.CountryAssetClasses,
        [countryToChange]: {
          AssetClasses: state.CountryAssetClasses[countryToChange].AssetClasses,
          enabled: !state.CountryAssetClasses[countryToChange].enabled,
        },
      },
    }));
  }
};

export const Originators = compose(
  organisationConnector,
  UsersOverviewConnector,
)(OriginatorsComponent);
